export default __webpack_public_path__ + "media/images/icons/portfolio-filled-fc050c46c72d2cde153169c686cf3872.svg";